"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MfaEnrollmentCompleteRequestSchema () {
        return MfaEnrollmentCompleteRequestSchema;
    },
    get MfaEnrollmentCompleteResponseSchema () {
        return MfaEnrollmentCompleteResponseSchema;
    }
});
const _zod = require("zod");
const MfaEnrollmentCompleteRequestSchema = _zod.z.object({
    code: _zod.z.string().regex(/^\d{6}$/, 'code must be 6 digits'),
    enrollmentToken: _zod.z.string().min(20)
}).strict();
const MfaEnrollmentCompleteResponseSchema = _zod.z.object({
    accessToken: _zod.z.string().min(1),
    refreshToken: _zod.z.string().min(1),
    expiresIn: _zod.z.number().int().positive(),
    recoveryCodes: _zod.z.array(_zod.z.string().min(1)).min(1)
}).strict();
